import "./grid.css.ts.vanilla.css-mistica.js";
var i = {
    start: "mfyikv36",
    end: "mfyikv37",
    center: "mfyikv38",
    stretch: "mfyikv39",
    baseline: "mfyikv3a"
}, m = {
    1: "mfyikv2e",
    2: "mfyikv2f",
    3: "mfyikv2g",
    4: "mfyikv2h",
    5: "mfyikv2i",
    6: "mfyikv2j",
    7: "mfyikv2k",
    8: "mfyikv2l",
    9: "mfyikv2m",
    10: "mfyikv2n",
    11: "mfyikv2o",
    12: "mfyikv2p"
}, f = "mfyikv1o", y = "mfyikv1p", k = "mfyikv6", e = {
    start: "mfyikv1h",
    end: "mfyikv1i",
    center: "mfyikv1j",
    stretch: "mfyikv1k",
    "space-between": "mfyikv1l",
    "space-around": "mfyikv1m",
    "space-evenly": "mfyikv1n"
}, r = {
    start: "mfyikv15",
    end: "mfyikv16",
    center: "mfyikv17",
    stretch: "mfyikv18",
    baseline: "mfyikv19"
}, a = {
    column: "mfyikvx",
    row: "mfyikvy",
    "row dense": "mfyikvz",
    "column dense": "mfyikv10"
}, t = {
    start: "mfyikv1a",
    end: "mfyikv1b",
    center: "mfyikv1c",
    stretch: "mfyikv1d",
    "space-between": "mfyikv1e",
    "space-around": "mfyikv1f",
    "space-evenly": "mfyikv1g"
}, n = {
    start: "mfyikv11",
    end: "mfyikv12",
    center: "mfyikv13",
    stretch: "mfyikv14"
}, s = {
    1: "mfyikv9",
    2: "mfyikva",
    3: "mfyikvb",
    4: "mfyikvc",
    5: "mfyikvd",
    6: "mfyikve",
    7: "mfyikvf",
    8: "mfyikvg",
    9: "mfyikvh",
    10: "mfyikvi",
    11: "mfyikvj",
    12: "mfyikvk"
}, o = "mfyikv7", l = {
    1: "mfyikvl",
    2: "mfyikvm",
    3: "mfyikvn",
    4: "mfyikvo",
    5: "mfyikvp",
    6: "mfyikvq",
    7: "mfyikvr",
    8: "mfyikvs",
    9: "mfyikvt",
    10: "mfyikvu",
    11: "mfyikvv",
    12: "mfyikvw"
}, c = "mfyikv8", d = {
    start: "mfyikv32",
    end: "mfyikv33",
    center: "mfyikv34",
    stretch: "mfyikv35"
}, u = {
    1: "mfyikv2q",
    2: "mfyikv2r",
    3: "mfyikv2s",
    4: "mfyikv2t",
    5: "mfyikv2u",
    6: "mfyikv2v",
    7: "mfyikv2w",
    8: "mfyikv2x",
    9: "mfyikv2y",
    10: "mfyikv2z",
    11: "mfyikv30",
    12: "mfyikv31"
}, p = {
    1: "mfyikv1q",
    2: "mfyikv1r",
    3: "mfyikv1s",
    4: "mfyikv1t",
    5: "mfyikv1u",
    6: "mfyikv1v",
    7: "mfyikv1w",
    8: "mfyikv1x",
    9: "mfyikv1y",
    10: "mfyikv1z",
    11: "mfyikv20",
    12: "mfyikv21"
}, g = {
    1: "mfyikv22",
    2: "mfyikv23",
    3: "mfyikv24",
    4: "mfyikv25",
    5: "mfyikv26",
    6: "mfyikv27",
    7: "mfyikv28",
    8: "mfyikv29",
    9: "mfyikv2a",
    10: "mfyikv2b",
    11: "mfyikv2c",
    12: "mfyikv2d"
}, w = {
    rowGap: "var(--mfyikv0)",
    columnGap: "var(--mfyikv1)",
    rowMinSize: "var(--mfyikv2)",
    rowMaxSize: "var(--mfyikv3)",
    columnMinSize: "var(--mfyikv4)",
    columnMaxSize: "var(--mfyikv5)"
};
export { i as alignSelf, m as columnStart, f as fullColumns, y as fullRows, k as grid, e as gridAlignContent, r as gridAlignItems, a as gridAutoFlow, t as gridJustifyContent, n as gridJustifyItems, s as gridTemplateColumns, o as gridTemplateColumnsAutoRepeat, l as gridTemplateRows, c as gridTemplateRowsAutoRepeat, d as justifySelf, u as rowStart, p as spanColumns, g as spanRows, w as vars };
